import { BarChart3, History, SlidersHorizontal } from "lucide-react";

import { PageTabs, PageTabItem } from "@/components/shared/PageTabs";
import { TopBarSection } from "@/components/shared/SecaoBarraSuperior";

import { RegrasEnvioPanel } from "./components/RegrasEnvioPanel";
import { HistoricoTab } from "./tabs/HistoricoTab";
import { PorCanalTab } from "./tabs/PorCanalTab";

const tabs: PageTabItem[] = [
  {
    value: "regras",
    label: "Regras de envio",
    icon: SlidersHorizontal,
    content: <RegrasEnvioPanel />,
  },
  { value: "historico", label: "Histórico", icon: History, content: <HistoricoTab /> },
  { value: "porCanal", label: "Envios por canal", icon: BarChart3, content: <PorCanalTab /> },
];

const NotificacoesAdminPage = () => {
  return (
    <div className="space-y-6 pb-10 duration-500 animate-in fade-in">
      <TopBarSection
        entity="Admin"
        title="Notificações"
        subtitle="O que pode sair por cada canal e o histórico dos envios"
      />

      <PageTabs tabs={tabs} paramKey="tab" />
    </div>
  );
};

export default NotificacoesAdminPage;
